import type { GalleryItem, WishItem } from "../models/contracts";
import type { MemoryHistoryEntry } from "./types";

const ageBoost = (createdAt: string, now: number) => Math.max(0, 18 - (now - Date.parse(createdAt)) / 60_000);
const recentPenalty = (type: MemoryHistoryEntry["type"], id: string, history: MemoryHistoryEntry[], now: number) => {
  const recent = [...history].reverse().find(item => item.type === type && item.id === id);
  return recent ? Math.max(0, 120 - (now - recent.shownAt) / 10_000) : 0;
};

export function rankGallery(items: GalleryItem[], history: MemoryHistoryEntry[], now: number): GalleryItem[] {
  return [...items].sort((a, b) => scoreGallery(b, history, now) - scoreGallery(a, history, now) || a.id.localeCompare(b.id));
}
function scoreGallery(item: GalleryItem, history: MemoryHistoryEntry[], now: number): number {
  const pixels = (item.width ?? 0) * (item.height ?? 0);
  return (item.isHighlighted ? 80 : 0) + ageBoost(item.createdAt, now) + Math.min(12, pixels / 500_000)
    + (item.mediaType.toLowerCase() === "video" ? 3 : 0) - recentPenalty("gallery", item.id, history, now);
}

export function rankWishes(items: WishItem[], history: MemoryHistoryEntry[], now: number): WishItem[] {
  return [...items].sort((a, b) => scoreWish(b, history, now) - scoreWish(a, history, now) || a.id.localeCompare(b.id));
}
function scoreWish(item: WishItem, history: MemoryHistoryEntry[], now: number): number {
  const readable = item.text.length <= 420 ? 8 : 2;
  return (item.isHighlighted ? 80 : 0) + ageBoost(item.createdAt, now) + readable + (item.photoUrl ? 5 : 0)
    - recentPenalty("wish", item.id, history, now);
}
